export const transformPayload = (payload: Record<string, any>, propsToChange: Record<string, string>) => {
    for(const propName in propsToChange) {
      if(payload.hasOwnProperty(propName)) {
        const newPropName = propsToChange[propName];
        
        payload[newPropName] = payload[propName];
        delete payload[propName];
      }
    }
  };


type Plan = {
  name: string;
  codname: string;
  features: Record<string, boolean>,
};

type Tier = {
  flat_amount: number,
  start_from: number,
  unit_amount: number,
  up_to: number,
};

export const calculateTotalCost = (employeeCount: number, tiers: Tier[], customerType: 'consultant' | 'company') => {
    const consultantDiscount = 0.3;
    const tiersFiltered: Tier[] = [];
    
    for(const tier of tiers) {
      tiersFiltered.push(tier);
      if(tier.up_to >= employeeCount)
        break;
    }

    const price = tiersFiltered.reduce(
      (acc: number, curr: Tier) => {
        const unit_amount = (curr.unit_amount || 0) / 1.22;
        const flat_amount = (curr.flat_amount || 0) / 1.22;
        const up_to = Math.min(curr.up_to, employeeCount);
        const start_from = curr.start_from;

        const employeeToCalc = (up_to + 1 - start_from)
        const tierPrice = acc + (unit_amount * employeeToCalc + flat_amount)
        return tierPrice;
      },
      0
    )

    let discountedPrice: number = parseFloat(price.toFixed(2));

    if (customerType === 'consultant') {
        discountedPrice *= (1 - consultantDiscount);
    }

    return { original: parseFloat(price.toFixed(2)), discounted: discountedPrice.toFixed(2) };
};


export const estraiMessaggiErrore = (error: any): string => {
  let errorMessage = 'Errore, riprova più tardi.';

  if (error?.response?.data) {
    const errorData = error.response.data;
    const errorMessages: string[] = [];

    Object.keys(errorData).forEach((key) => {
      const messageArray = errorData[key];
      if (Array.isArray(messageArray)) {
        errorMessages.push(...messageArray);
      } else if (typeof messageArray === 'string') {
        errorMessages.push(messageArray);
      }
    });

    if (errorMessages.length > 0) {
      errorMessage = errorMessages.join(' ');
    }
  }

  return errorMessage;
};
